import _ from 'lodash'

const partenaire = (data) => {
	const partenaires = data.map(
		({
			id,
			title: { rendered: title },
			categories,
			acf: { description, lien: link },
			_embedded: { 'wp:term': term },
		}) => {
			return {
				id,
				title,
				description,
				termName: term[0][0].name,
				link,
				categorie: categories[0].toString(),
			}
		},
	)

	debugger
	const partenairesSorted = _.sortBy(partenaires, ['termName'])
	return _.groupBy(partenairesSorted, 'termName')
}

export default partenaire
